import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventPaste]'
})
export class PreventPasteDirective {
  constructor() {
  }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/directives/prevent-paste.ts